import { Button, Input, message } from 'antd';
import React, { useEffect, useState } from 'react';
// @ts-ignore
import AsteriTitle from 'src/assets/asteri-title.svg?react';

import { AUTH_DATA_STORAGE_KEY } from '../../common/constants';
import { useTypedDispatch } from '../../hooks/useTypedDispatch';
import { authApi } from '../../store/api/auth.api';
import { LoginDto } from '../../store/api/types.api';
import {
  setAccessToken,
  setAuthLoading,
} from '../../store/reducers/common.slice';
import styles from './Login.module.scss';

const initialFormData: LoginDto = {
  login: '',
  password: '',
};

export const Login = () => {
  const dispatch = useTypedDispatch();
  const [errorAuth, setErrorAuth] = useState({
    error: false,
    message: '',
  });
  const [formData, setFormData] = useState<LoginDto>(initialFormData);

  const [login, { data: loginResponseData, isLoading: loadingLogin }] =
    authApi.useLazyLoginQuery();

  const handleChangeInput =
    (name: keyof LoginDto) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({ ...formData, [name]: e.target.value });
    };

  const handleLoginBtnClick = async () => {
    const res = await login(formData);

    if (res.data) {
      localStorage.setItem(AUTH_DATA_STORAGE_KEY, JSON.stringify(res.data));

      dispatch(setAccessToken(res.data.accessToken));
      dispatch(setAuthLoading(true));
    }

    if (res.status === 'rejected') {
      setErrorAuth({
        error: true,
        message: 'Неверный логин или пароль',
      });
    }
  };

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles['container__logo']}>
          {/* <AsteriTitle /> */}
          {/* Пока не удалять */}
        </div>

        <div className={styles['container__fields']}>
          <Input
            size="large"
            placeholder="Логин"
            onChange={handleChangeInput('login')}
          />

          <Input.Password
            size="large"
            placeholder="Пароль"
            onChange={handleChangeInput('password')}
          />

          <Button
            loading={loadingLogin}
            size="large"
            type="primary"
            onClick={handleLoginBtnClick}
          >
            Войти
          </Button>
        </div>

        {errorAuth.error && (
          <p className={styles['container__error']}>{errorAuth.message}</p>
        )}
      </div>
    </div>
  );
};
